/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import { rect, rectsEqual, sizesEqual } from './rect'
import { deepEqual } from './util'

const defaultShapeOptions = {
    fill: false,
    stroke: false,
    lineWidth: 1,
    shadow: false,
    opacity: 1,
    visible: 1
}

let lastId = 0



export default class Shape {

    static Rectangle(rect, opts = null) {
        return new Shape(Shape.Types.Rectangle, rect, opts)
    }

    static Ellipse(rect, opts = null) {
        return new Shape(Shape.Types.Ellipse, rect, opts)
    }

    static Group(rect, opts = null) {
        return new Shape(Shape.Types.Group, rect, opts)
    }

    constructor(type, rct, opts = null) {
        this._id = (lastId ++)
        this._type = type
        this._frame = rct ? rct : rect(0, 0, 10, 10)
        this._props = Object.assign({}, defaultShapeOptions, opts ? opts : {})
        this._children = []
    }

    get type() {
        return this._type
    }

    get frame() {
        return this._frame
    }

    set frame(val) {
        if (! rectsEqual(this._frame, val)) {
            if (! sizesEqual(this._frame, val)) {
                this.markDirty()
            }
            this._frame = val
        }
    }

    get props() {
        return this._props
    }

    set props(val) {
        if (! deepEqual(this._props, val)) {
            this.markDirty()
            this._props = val
        }
    }

    get cacheKey() {
        let key = ''
        key += this._type + '-'
        key += this._frame.w + '-'
        key += this._frame.h + '-'
        key += this._props.fill + '-'
        key += this._props.stroke + '-'
        key += this._props.lineWidth + '-'
        key += this._props.shadow + '-'
        return key
    }

    get children() {
        return this._children
    }

    set children(val) {
        this._children = val
    }

}

Shape.Types = {
    Rectangle: 1,
    Ellipse: 2,
    Group: 99,
}
